module.exports = __webpack_public_path__ + "84bec1b4919b06cb6184d68f8488686b.svg";